import { HalfedgeDS } from '../core/HalfedgeDS';
import { Vertex } from '../core/Vertex';

/**
 * Bridges two connected vertex paths by creating a strip of triangles
 * between them. Works with different path lengths (fans the remainder).
 *
 * Assumptions:
 *  - pathA and pathB are already "connected" chains (edges between consecutive vertices exist)
 *  - topology allows adding faces between these chains (no non-manifold conflicts)
 */
export function bridgeSegments(struct: HalfedgeDS, pathA: Vertex[], pathB: Vertex[]): void {
  if (!pathA?.length || !pathB?.length) return;

  // Walk both paths in lock-step building quads as two triangles
  let i = 0,
    j = 0;
  while (i < pathA.length - 1 && j < pathB.length - 1) {
    const A0 = pathA[i],
      A1 = pathA[i + 1];
    const B0 = pathB[j],
      B1 = pathB[j + 1];

    // Quad (A0, A1, B1, B0) -> triangles: (A0,A1,B1) + (A0,B1,B0)
    struct.createFace(A0, A1, B1);
    struct.createFace(A0, B1, B0);

    i++;
    j++;
  }

  // If A has remainder, fan to last B
  while (i < pathA.length - 1) {
    const A0 = pathA[i],
      A1 = pathA[i + 1],
      Blast = pathB[pathB.length - 1];
    struct.createFace(A0, A1, Blast);
    i++;
  }

  // If B has remainder, fan to last A
  while (j < pathB.length - 1) {
    const Alast = pathA[pathA.length - 1],
      B0 = pathB[j],
      B1 = pathB[j + 1];
    struct.createFace(Alast, B1, B0);
    j++;
  }
}
